import React, { useEffect } from 'react'
import { Table, Switch, message, Typography, Alert, Spin } from 'antd'
import api from '@/services/api'
import getCatalogName from '@/helpers/getCatalogName';

const { Title } = Typography

const ManagementLanguages = () => {
    const [data, setData] = React.useState([]);
    const [loadingFetch, setLoadingFetch] = React.useState(false);
    const [loadingState, setLoadingState] = React.useState(null); // Track which language is being toggled

    const [tecdocLoading, setTecdocLoading] = React.useState(false);
    const [tecdocLangList, setTecdocLangList] = React.useState([]);

    const catalogName = getCatalogName();

    const fetchTecdocProvider = async () => {
        setTecdocLoading(true);
        try {
            const response = await api()({
                url: '/webshop/management/tecdoc-provider-info',
                method: 'get'
            });


            setTecdocLangList(response.data || []);

        } catch (error) {
            console.error(error);
            message.error('Error fetching Tecdoc provider');
        } finally {
            setTecdocLoading(false);
        }
    }

    const fetchLanguages = async () => {
        setLoadingFetch(true);
        try {
            const response = await api()({
                url: '/webshop/management/languages',
                method: 'get'
            });
            setData(response.data);
            message.success('Languages fetched successfully');
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch languages');
        } finally {
            setLoadingFetch(false);
        }
    }

    const handleToggleLanguage = async (languageCode, isActive) => {
        setLoadingState(languageCode); // Set loading for the specific language
        try {
            const newStatus = isActive === 1 ? 0 : 1;
            await api()({
                url: `/webshop/management/languages/${languageCode}/toggle?status=${newStatus}`,
                method: 'put',
            });
            setData(prevData =>
                prevData.map(lang =>
                    lang.Code === languageCode ? { ...lang, Active: newStatus } : lang
                )
            );
            message.success('Language status updated successfully');
        } catch (error) {
            console.error(error);
            message.error('Failed to update language status');
        } finally {
            setLoadingState(null); // Reset loading state after update
        }
    }

    useEffect(() => {
        fetchLanguages();

        if (catalogName == 'TECDOC') {
            fetchTecdocProvider();
        }

    }, []);

    const columns = [
        {
            title: 'Language Name',
            dataIndex: 'Name',
            key: 'Name',
        },
        {
            title: 'Language Code',
            dataIndex: 'Code',
            key: 'Code',
        },
        {
            title: 'Active',
            key: 'Active',
            render: (_, record) => (
                <Switch
                    checked={record.Active === 1}
                    loading={loadingState === record.Code} // Show loading for the toggled language only
                    onChange={() => handleToggleLanguage(record.Code, record.Active)}
                />
            ),
        },
    ];

    return (
        <div>

            {(catalogName === 'TECDOC' && tecdocLangList?.length) ?
                <Spin spinning={tecdocLoading}>
                    <Alert banner message={
                        <>
                            Your tecdoc provider is <strong>{tecdocLangList[0]?.ProviderName}</strong> and the active languages are:
                            <ul>
                                {tecdocLangList.map((lang, index) => (
                                    <li key={index}>
                                        {lang}
                                    </li>
                                ))}
                            </ul>
                            <p>
                                If you want to change the active languages, please contact your tecdoc provider.
                            </p>
                        </>

                    } />

                </Spin> : null}
                    <br/>
            <Title level={3}>Languages Management</Title>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="Code"
                loading={loadingFetch}
                pagination={false}
                bordered
            />
        </div>
    );
};

export default ManagementLanguages;
